import { getRequestOptionDemoMode } from '@/utils/demoMode';
import { getStorageCompanyId } from '@/utils/localStorage';
import { request } from 'umi';

export const getConversionListAPI = async (
  params: API.ConversionListGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.ConversionList>('/conversion/list', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getConversionDailyAPI = async (
  params: API.ConversionDailyGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.ConversionDaily>('/conversion/daily', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode('audienceName'),
  });
};

export const getConversionUserJourneyAPI = async (
  params: API.ConversionUserJourneyGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.ConversionUserJourney>('/conversion/user_journey', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getConversionDimensionAPI = async (
  params: API.ConversionDimensionGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.ConversionDimension>('/conversion/dimension', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode('conversionEvent'),
  });
};

export const getConversionDimensionAllAPI = async (
  params: API.ConversionDimensionAllGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.ConversionDimensionAll>('/conversion/dimension/all', {
    params: { ...params, companyId },
    ...options,
  });
};

export const getConversionSourceMediumAPI = async (
  params: API.ConversionSourceMediumGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.ConversionSourceMedium>('/conversion/source_medium', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

export const getOverviewAPI = async (
  params: API.ConversionOverviewGetParameters,
  options?: API.RequestOptions,
) => {
  const companyId = getStorageCompanyId();
  return request<API.RevenueOverview>('/conversion/overview', {
    params: { ...params, companyId },
    ...options,
    ...getRequestOptionDemoMode(),
  });
};
